module.exports = __webpack_public_path__ + "static/media/mario.a31c206e.png";